export enum CourseStateType {
  Draft = 0,
  Published = 1,
  // Unpublished = 2
  Imparted = 3,
  Soon = 4,
  Inactive = 5,
}

export const CourseStateTypeInverse = {
  [CourseStateType.Draft]: 'draft',
  [CourseStateType.Published]: 'published',
  [CourseStateType.Imparted]: 'imparted',
  [CourseStateType.Soon]: 'soon',
  [CourseStateType.Inactive]: 'inactive',
}
